var ActionsType;
(function(ActionsType) {
    ActionsType["UPDATE_LICENSE"] = "UPDATE_LICENSE";
    ActionsType["FETCH_LIMITS"] = "FETCH_LIMITS";
    ActionsType["UPDATE_LIMITS"] = "UPDATE_LIMITS";
})(ActionsType || (ActionsType = {}));
var update = function(license) {
    return {
        type: ActionsType.UPDATE_LICENSE,
        payload: {
            license: license
        }
    };
};
export var LicenseActions = {
    ActionsType: ActionsType,
    update: update
};

//# sourceMappingURL=LicenseActions.js.map